import React from "react";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUser } from "../../features/user/userSlice";
import { useState } from "react";
import crearUsuario from "../../assets/images/add-user.png";
import { selectAuth } from "../../features/user/userSlice";
import AccountCircle from "@mui/icons-material/AccountCircle";
import PasswordIcon from "@mui/icons-material/Password";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import clsx from "clsx";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  CircularProgress,
  Grid,
  Button,
  Card,
  CardContent,
  CardMedia,
  CardActionArea,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import {
  useCreateUserMutation,
  useGetUsersQuery,
  useDeleteUserMutation,
  useActiveUserMutation,
  useChangePasswordMutation,
  useGetUsersCalendarQuery,
  useCreateUserCalendarMutation,
  useChangeStateUserCalendarMutation,
} from "../../features/api/apiYeapGo";
import {
  CheckCircleOutline,
  HighlightOffOutlined,
  LockOutlined,
  MailOutline,
  PhoneCallback,
} from "@mui/icons-material";

export const UsersCalendar = () => {
  /* Login */
  const Auth = useSelector(selectAuth);
  const { data, isLoading } = useGetUsersCalendarQuery({ Token: Auth });
  const [openDialog, setOpenDialog] = useState(false);
  const [passwordID, setPasswordID] = useState("");
  const [newPassword, setNewPassword] = useState("");
  // const [action, setAction] = useState("crear");
  const user = useSelector(selectUser);
  const [createUser] = useCreateUserCalendarMutation();
  const [deleteUser] = useDeleteUserMutation();
  const [activeUser] = useChangeStateUserCalendarMutation();

  const [changePassword] = useChangePasswordMutation();
  //const [updateUser] = useUpdateUserMutation();
  let navigate = useNavigate();
  React.useEffect(() => {
    if (!user.Token) {
      navigate("login");
    } else if (user.Rol !== "Administrador") {
      swal(
        "Sin permisos suficientes",
        "Para gestionar usuarios debe ser Administrador",
        "error"
      );
      navigate("/");
    }
  }, [user]);

  const [dataUser, setDataUser] = useState({
    nombre: "",
    telefono: "",
    correo: "",
  });

  /* table columns */
  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
    },

    {
      field: "nombre",
      headerName: "Nombre",
      width: 200,
    },
    {
      field: "telefono",
      headerName: "Telefono",
      width: 125,
    },
    {
      field: "correo",
      headerName: "Correo",
      width: 300,
      // cellClassName: (params) => {
      //   if (params.value == null) {
      //     return "";
      //   }
      //   return clsx("super-app", {
      //     active: params.value === "ACTIVO",
      //     inactive: params.value === "INACTIVO",
      //   });
      // },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 400,
      sortable: false,
      renderCell: (params) => {
        const activarUsuario = (e) => {
          e.stopPropagation();
          console.log(params.row);
          activeUser({
            id: params.row.id,
            Token: Auth,
            body: { id: params.row.id },
          });
        };

        return (
          <div>
            {params.row.activo === 1 ? (
              <Button
                variant="text"
                color="primary"
                startIcon={<HighlightOffOutlined />}
                onClick={activarUsuario}
              >
                DESHABILITAR
              </Button>
            ) : (
              <Button
                variant="text"
                color="secondary"
                startIcon={<CheckCircleOutline />}
                onClick={activarUsuario}
              >
                HABILITAR
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  /* Formularios */
  const [open, setOpen] = React.useState(false);

  const handleClose = (action) => {
    setOpen(false);
  };

  /* Validaciones */
  const validateForm = () => {
    if (
      dataUser.nombre === "" ||
      dataUser.telefono === "" ||
      dataUser.correo === ""
    ) {
      return false;
    } else {
      return true;
    }
  };

  /* Crear Usuario */
  const CrearUsuario = async () => {
    if (validateForm()) {
      setDataUser({
        ...dataUser,
      });
      createUser({
        Token: user.Token,
        body: dataUser,
      })
        .unwrap()
        .then(() => {
          setOpen(false);
          setDataUser({
            nombre: "",
            telefono: "",
            correo: "",
          });
          swal({
            title: "Usuario Creado Correctamente",
            icon: "success",
          });
        })
        .catch((err) => {
          swal({
            title: `Hubo un error al crear el usuario ${err}`,
            icon: "error",
          });
        });
    } else {
      swal({
        title: "Por favor ingrese todos los datos.",
        icon: "error",
      });
    }
  };
  return (
    <Grid
      container
      direction="row"
      spacing={2}
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs={12} md={3} sx={{ height: 300, width: "100%" }}>
        <Card>
          <CardActionArea>
            <CardMedia
              component="img"
              width="100%"
              image={crearUsuario}
              alt="Crear Usuario"
              onClick={() => {
                setOpen(true);
                // setAction("crear");
              }}
            />
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Crear Usuario
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>

      {/* Tabla */}
      <Grid
        item
        xs={12}
        md={9}
        sx={{
          height: 300,
          width: "100%",
          "& .super-app-theme--cell": {
            backgroundColor: "rgba(224, 183, 60, 0.3)",
          },
          "& .super-app.inactive": {
            color: "#e5007c",
          },
        }}
      >
        {isLoading ? (
          <CircularProgress color="secondary" />
        ) : (
          <>
            <DataGrid
              density={"compact"}
              autoHeight
              rows={data || []}
              pageSize={10}
              columns={columns}
              disableSelectionOnClick
              components={{ Toolbar: GridToolbar }}
              getRowId={(row) => row.id}
              // onSelectionModelChange={(e) => setEventsID(e)}
            />
          </>
        )}
      </Grid>

      {/* Formularios */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
      >
        <DialogTitle>
          <DialogTitle id="scroll-dialog-title">CREAR USUARIO</DialogTitle>
        </DialogTitle>
        <DialogContent style={{ cursor: "pointer" }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "2%",
              }}
            >
              <TextField
                fullWidth
                required
                onChange={(e) =>
                  setDataUser({
                    ...dataUser,
                    nombre: e.target.value,
                  })
                }
                label="Nombre"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "2%",
              }}
            >
              <TextField
                fullWidth
                required
                type={"number"}
                onChange={(e) =>
                  setDataUser({
                    ...dataUser,
                    telefono: e.target.value,
                  })
                }
                label="Telefono"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneCallback />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                marginTop: "2%",
              }}
            >
              <TextField
                fullWidth
                required
                type={"email"}
                onChange={(e) =>
                  setDataUser({
                    ...dataUser,
                    correo: e.target.value,
                  })
                }
                label="Correo"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MailOutline />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => CrearUsuario(dataUser)}
          >
            Crear usuario
          </Button>
          <Button onClick={handleClose} color="secondary">
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Cambiar Contraseña</DialogTitle>
        <DialogContent>
          <TextField
            label="Nueva Contraseña"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            fullWidth
            margin="normal"
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancelar</Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!newPassword}
            onClick={() => {
              changePassword({
                Token: Auth,
                body: { id: passwordID, newPassword },
              })
                .then(() => {
                  setOpenDialog(false);
                  setNewPassword("");
                  swal({
                    title: "Contraseña actualizada correctamente",
                    icon: "success",
                  });
                })
                .catch((error) => {
                  swal({
                    title:
                      "Hubo un error al cambiar la contraseña. Por favor, inténtalo de nuevo.",
                    icon: "error",
                  });
                });
            }}
          >
            Cambiar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};
